/**
 * Obtiene headers estándar y limpios para peticiones HTTP.
 * No inyecta headers no estándar frágiles (x-user-role) para evitar bloqueos
 * en diferentes navegadores, modo incógnito o políticas de privacidad.
 */
export async function getClientAuthHeaders(): Promise<HeadersInit> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  try {
    const userStr = localStorage.getItem('auth_user_session');
    if (userStr) {
      const user = JSON.parse(userStr);
      if (user?.id || user?.uid) {
        headers['x-user-id'] = user.id || user.uid;
      }
    }
  } catch (error) {
    console.warn('[clientAuthHeaders] Error leyendo identificador de usuario:', error);
  }

  return headers;
}
